import { render } from "./link-list.vue?vue&type=template&id=ca6899c0"
import script from "./link-list.vue?vue&type=script&lang=js"
export * from "./link-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__